var React = require('react');

function IconCalendarO (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M924.4 236.2c-.1-38-31.7-68.8-69.5-68.7l-157.7.4V98.2h-53.6v69.7H536.4V98.2h-53.6v69.7H375.6V98.2H322v69.7H168.9c-38.1 0-69 30.7-68.9 68.8l1.2 622.8c.1 38 31.4 68.8 69 68.8h686.7c38 0 68.8-30.8 68.7-68.9l-1.2-623.2zm-69.8 596.3c0 14.8-12 26.8-26.8 26.8H189.3c-14.8 0-26.8-12-26.8-26.8V261.9c0-14.8 12-26.8 26.8-26.8h134.1v53.6H377v-53.6h107.2v53.6h53.6v-53.6H645v53.6h53.6v-53.6h129.2c14.8 0 26.8 12 26.8 26.8v570.6z","key":0}),React.createElement("path",{"d":"M272.5 365.4h110.8v55.4H272.5zM457.1 365.4h110.8v55.4H457.1zM640.7 365.4h110.8v55.4H640.7zM272.5 526.3h110.8v55.4H272.5zM457.1 526.3h110.8v55.4H457.1zM640.7 526.3h110.8v55.4H640.7zM272.5 687.1h110.8v55.4H272.5zM457.1 687.1h110.8v55.4H457.1zM640.7 687.1h110.8v55.4H640.7z","key":1})]));
}

IconCalendarO.displayName = "IconCalendarO";

IconCalendarO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCalendarO;

IconCalendarO.default = IconCalendarO;
